import { render, staticRenderFns } from "./CardMinhaMatricula.vue?vue&type=template&id=11bb61fa&"
import script from "./CardMinhaMatricula.vue?vue&type=script&lang=js&"
export * from "./CardMinhaMatricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports